<template>
  <div id="split-layout-comp">
    <Layout :resize="true" :edit="true" :splits="tree">
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._i" :key="key" class="nav-item">
              <div
                class="nav-link widget-tab"
                :class="layout_selection._i === key ? 'active' : ''"
                @click="updateLayout('_i', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x"
                  class="
                    custom-box-css
                    box-x box-icon
                    widget-tab__button widget-tab__button--back
                  "
                  @click.stop="removeTabFromLayout('_i', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_i', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._i[layout_selection._i]"></component>
        </div>
      </Pane>
      <!-- 0 - view -->
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._j" :key="key" class="nav-item">
              <div
                class="nav-link"
                :class="layout_selection._j === key ? 'active' : ''"
                @click="updateLayout('_j', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x-circle"
                  color="#659DBD"
                  class="custom-box-css box-x"
                  @click.stop="removeTabFromLayout('_j', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_j', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._j[layout_selection._j]"></component>
        </div>
      </Pane>
      <!-- 1 - view -->
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._n" :key="key" class="nav-item">
              <div
                class="nav-link"
                :class="layout_selection._n === key ? 'active' : ''"
                @click="updateLayout('_n', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x-circle"
                  color="#659DBD"
                  class="custom-box-css box-x"
                  @click.stop="removeTabFromLayout('_n', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_n', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._n[layout_selection._n]"></component>
        </div>
      </Pane>
      <!-- 3 - view -->
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._k" :key="key" class="nav-item">
              <div
                class="nav-link"
                :class="layout_selection._k === key ? 'active' : ''"
                @click="updateLayout('_k', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x-circle"
                  color="#659DBD"
                  class="custom-box-css box-x"
                  @click.stop="removeTabFromLayout('_k', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_k', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._k[layout_selection._k]"></component>
        </div>
      </Pane>
      <!-- 3 - view -->
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._l" :key="key" class="nav-item">
              <div
                class="nav-link"
                :class="layout_selection._l === key ? 'active' : ''"
                @click="updateLayout('_l', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x-circle"
                  color="#659DBD"
                  class="custom-box-css box-x"
                  @click.stop="removeTabFromLayout('_l', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_l', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._l[layout_selection._l]"></component>
        </div>
      </Pane>
      <!-- 3 - view -->
      <Pane class="split-layout-custom-style">
        <div class="tab-top">
          <ul class="nav nav-tabs">
            <li v-for="(value, key) in layout._h" :key="key" class="nav-item">
              <div
                class="nav-link"
                :class="layout_selection._h === key ? 'active' : ''"
                @click="updateLayout('_h', key)"
              >
                <div class="tab-title">
                  {{ value }}
                </div>
                <box-icon
                  name="x-circle"
                  color="#659DBD"
                  class="custom-box-css box-x"
                  @click.stop="removeTabFromLayout('_h', key)"
                ></box-icon>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <box-icon
                  name="plus"
                  class="custom-box-css box-plussecondary"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></box-icon>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li v-for="(opt, key) in componentsOptions" :key="key">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="addTabToLayout('_h', opt.name)"
                      >{{ opt.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="tab-full">
          <component :is="layout._h[layout_selection._h]"></component>
        </div>
      </Pane>
      <!-- 2 - view -->
    </Layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Layout, Pane } from 'vue-split-layout';
import Recentevents from '@/components/Recentevents.vue';
import SearchedWord from '@/components/SearchedWord.vue';
import LinksVisited from '@/components/LinksVisited.vue';
import RecentActivity from '@/components/RecentActivity.vue';
import PieDump from '../components/PieDump.vue';

export default {
  name: 'PageDashboard',
  metaInfo: {
    title: 'Dashboard',
  },
  components: {
    Recentevents,
    Layout,
    Pane,
    SearchedWord,
    PieDump,
    LinksVisited,
    RecentActivity,
  },
  data() {
    return {
      tree: {
        dir: 'horizontal', // Left | Right
        // Other split
        first: {
          dir: 'vertical',
          first: 0, // these numbers represents the views slot ID
          second: 2,
        },
        second: {
          dir: 'horizontal',
          first: {
            dir: 'vertical',
            first: 1,
            second: 5,
          },
          second: {
            dir: 'vertical',
            first: 3,
            second: 4,
            split: '50%',
          },
          split: '70%',
        },
        split: '25%',
      },
      layout: {
        _h: ['RecentActivity'],
        _i: ['Recentevents'],
        _j: ['SearchedWord'],
        _k: ['LinksVisited'],
      },
      layout_selection: {
        _h: 0,
        _i: 0,
        _j: 0,
        _k: 0,
        _l: 0,
        _m: 0,
        _n: 0,
      },
      componentsOptions: [
        {
          name: 'Recentevents',
          component: Recentevents,
          options: {
            title: 'Events',
            description: 'View all your events',
          },
        },
        {
          name: 'RecentActivity',
          component: RecentActivity,
          options: {
            title: 'Activities',
            description: 'View all your Activities',
          },
        },
        {
          name: 'PieDump',
          component: PieDump,
          options: {
            title: 'Usage',
            description: 'View all your notes',
          },
        },
        {
          name: 'LinksVisited',
          component: LinksVisited,
          options: {
            title: 'Links',
            description: 'Top most Links Visited',
          },
        },
        {
          name: 'SearchedWord',
          component: SearchedWord,
          options: {
            title: 'Words',
            description: 'Top most Searched Words',
          },
        },
      ],
    };
  },
  methods: {
    updateLayout(key, index) {
      this.layout_selection[key] = index;
      this.updateLayoutToState();
    },
    removeTabFromLayout(key, index) {
      this.layout[key].splice(index, 1);
      this.updateLayoutToState();
    },
    addTabToLayout(key, component) {
      this.layout[key].push(component);
      this.updateLayoutToState();
    },
    // merge this.layout with this.$store.state.layout.layout_tabs
    updateLayoutBasedOnState() {
      this.layout = this.$store.state.layout.layout_tabs;
      this.layout_selection = this.$store.state.layout.layout_tab_selection;
      console.log('Updated');
      console.log(this.layout);
      console.log(this.layout_selection);
    },
    updateLayoutToState() {
      this.$store.dispatch('updateLayoutSettings', {
        layout: this.layout,
        layout_selection: this.layout_selection,
      });
    },
  },

  computed: {
    randomNumer() {
      return Math.random();
    },
    showMeta() {
      if (this.$store.state.wikiInformation) {
        const wikiInfoLength = this.$store.state.wikiInformation.length;
        if (wikiInfoLength > 0) {
          return true;
        }
      }
      if (
        this.$store.state.selectedNode
        && this.$store.state.selectedNode.nodeLabel
      ) {
        return true;
      }
      console.log(this.$store.state.wolframInformation);
      if (
        this.$store.state.wolframInformation
        && this.$store.state.wolframInformation.answer
      ) {
        return true;
      }
      return false;
    },

    showExploreDescription() {
      return this.$store.state.explore.extract;
    },

    ...mapGetters({
      user: 'auth/authUser',
    }),
  },
  mounted() {
    const thoughtId = this.$route.params.id;
    if (thoughtId) {
      console.log('Firing Getting Saved State');
      this.$store.dispatch('getSavedTjState', thoughtId);
    }

    this.updateLayoutBasedOnState();
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (
        mutation.type === 'SET_LAYOUT_SETTINGS'
        || mutation.type === 'SET_SAVED_TJ_STATE'
      ) {
        this.updateLayoutBasedOnState();
      }
    });
    this.$store.dispatch('mostSearchedWordList').then(() => {
      const wordArray = this.$store.state.mostSearchedWords;
      console.log(wordArray.length);
      const randomNumber = Math.floor(Math.random() * wordArray.length);
      this.$store.dispatch('fetchThreeDModel', wordArray[randomNumber].word);
      this.$store.dispatch('fetchVerb', 'SEARCHED_FOR').then(() => {
        this.$store.dispatch('wikiWordFetch', wordArray[randomNumber].word);
        this.$store.dispatch('wikiSnippet', {
          word: wordArray[randomNumber].word,
          type: 'word',
        });
        this.$store.dispatch(
          'fetchExploreInformation',
          wordArray[randomNumber].word,
        );
      });
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style scoped>
#split-layout-comp {
  height: 90vh;
  z-index: -5;
}
.split-layout-custom-style {
  border-radius: 5px;
  overflow-x: hidden !important;
}
.nav-tabs .nav-link {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.5em;
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  background: #f2f2f2;
  cursor: pointer;
}
.nav-item {
  display: flex;
  align-items: flex-end;
}
.custom-box-css {
  margin-left: 0.5em;
  transition: all ease-in 200ms;
  border-radius: 50%;
}
.custom-box-css:hover {
  cursor: pointer;
  background: rgba(154, 160, 166, 0.157);
}
</style>
